<template>
  <div class="box11">
    <img class="bg" src="../../../assets/coursePage/illinois/box11/bg.png" alt="">
  </div>
</template>

<script>
export default {
  components: {

  },
  data() {
    return {
      
    };
  },

  methods: {},
};
</script>

<style  lang="less" scoped>
.box11 {
  background: #fff;
  width: 100%;
  height: 706px;
  .bg {
    width: 100%;
    height: 706px;
    display: block;
  }
}
</style>
